import { isDevMode } from "../../electron-modules";

export class WorkerPool {
  private path;
  private workers = [];

  constructor(workerPath, numDefaultWorkers=1) {
    this.path = workerPath;
    this.createDefaultWorkers(numDefaultWorkers);
  }

  sendMessage(worker, data, transferables=null) {
    worker.postMessage(data, transferables);
  }

  getWorker() {
    if (this.workers.length === 0) {
      let worker = new Worker(this.path);
      this.returnWorker(worker);
    }

    let worker = this.workers.pop();

    return worker;
  }

  returnWorker(worker) {
    try {
      this.workers.push(worker);
    } catch (error) {
      return;
    }
  }


  createDefaultWorkers(numDefaultWorkers) {
    let newWorkers = [];
    for (let i=0; i<numDefaultWorkers; i++) {
      newWorkers.push(this.getWorker());
    }

    newWorkers.forEach(worker => {
      this.returnWorker(worker);
    });
  }

  terminateWorkers() {
    this.workers.forEach(worker => {
      worker.terminate();
    });

    this.workers = [];
  }
}

export class WorkerQueue {
  private pool: WorkerPool;
  private maxAsyncWorkers;
  private waitForExit = false;
  public numRunning = 0;
  private queue = [];

  constructor(workerURL, numWorkers, waitForExit=false) {
    let workerPath = `${process.env.PUBLIC_URL}/${workerURL}`;
    this.pool = new WorkerPool(workerPath, numWorkers);
    this.maxAsyncWorkers = numWorkers;
    this.waitForExit = waitForExit;

    if (waitForExit && isDevMode) {
      console.warn("WorkerQueue requires {workerFinished: true} message to stop");
    }
  }

  get running() {
    return this.numRunning > 0;
  }

  push(data, callback, transferables=[]) {
    this.queue.push([data, callback, transferables]);
  }

  /** @private */
  finish(worker) {
    this.numRunning = this.numRunning - 1;
    this.pool.returnWorker(worker);
  }

  process() {
    if (this.numRunning >= this.maxAsyncWorkers) {
      return;
    }

    if (this.queue.length === 0) {
      return;
    }

    this.numRunning = this.numRunning + 1;

    // Grab queue values
    let [workerData, workerCallback, transferables] = this.queue.shift();

    // Grab next available worker
    let worker = this.pool.getWorker();

    worker.onmessage = event => {
      let data = event.data;

      if (this.waitForExit) {
        if (data.workerFinished) {
          // Return worker to queue
          this.finish(worker);
          return;
        } else {
          // Execute callback
          workerCallback(event.data);
        }
      } else {
        // Execute callback
        workerCallback(event.data);

        // Return worker to queue
        this.finish(worker);
      }
    };

    // Submit data to webworker
    this.pool.sendMessage(worker, workerData, transferables);
  }
}
